import { MaterialIcon } from '@/components/MaterialIcon';
import { Button } from '@/components/Button';
import { Tag } from '@/components/Tag';
import Input from '@/components/Input';
import Select from '@/components/Select';
import { TAG_COLORS, COLOR_OPTIONS } from '@/constants/tagColors';
import type { AgentApiTagsRecord } from '@/types/serializers';

interface Props {
  editingTag: AgentApiTagsRecord | null;
  tagName: string;
  selectedColor: { name: string; value: string; label: string } | null;
  onTagNameChange: (value: string) => void;
  onColorChange: (color: { name: string; value: string; label: string }) => void;
  onDeleteTag: (tag: AgentApiTagsRecord) => void;
  onUpdateTag: () => void;
  isUpdating: boolean;
}

export default function TagSettingsForm({
  editingTag,
  tagName,
  selectedColor,
  onTagNameChange,
  onColorChange,
  onDeleteTag,
  onUpdateTag,
  isUpdating,
}: Props) {
  return (
    <div className="flex-1 rounded-sm bg-white p-lg shadow-layer1">
      <div className="flex flex-col gap-lg">
        <div className="flex items-center justify-between">
          <h3 className="text-heading-md text-main">タグ設定</h3>
          <Button
            onClick={() => editingTag && onDeleteTag(editingTag)}
            color="danger-secondary"
            size="md"
            disabled={!editingTag}
          >
            <MaterialIcon name="delete" filled className="text-xl" />
            タグを削除する
          </Button>
        </div>

        <div className="flex flex-col gap-sm">
          <div>
            <label className="mb-xs flex items-center gap-xs">
              <span className="text-heading-xxs text-main">タグタイトル</span>
              <Tag color="danger" size="sm">
                必須
              </Tag>
            </label>
            <Input
              value={tagName}
              onChange={(e) => onTagNameChange(e.target.value)}
              placeholder="タグタイトル（15文字以内）"
              maxLength={15}
              className="w-full"
              disabled={!editingTag}
            />
          </div>

          <div className="w-[218px]">
            <label className="mb-xs block text-heading-xxs text-main">カラー選択</label>
            <Select
              items={COLOR_OPTIONS}
              value={selectedColor?.label || ''}
              onValueChange={(value) => {
                const color = TAG_COLORS.find((c) => c.label === value);
                if (color) onColorChange(color);
              }}
              className="w-full"
              disabled={!editingTag}
            />
          </div>
        </div>

        <div className="flex justify-end">
          <Button
            onClick={onUpdateTag}
            color="primary"
            size="lg"
            disabled={!editingTag || !tagName.trim() || isUpdating}
          >
            {isUpdating ? '更新中...' : '適用する'}
          </Button>
        </div>
      </div>
    </div>
  );
}
